<template>
  <div class="crud_form_wrapper app_settings_class">
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #3eb6d4" class="font-weight-bold">
          {{ $t("SIDENAV.settings.general") }}
        </h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <div class="loader" v-if="loading">
        <div class="spinner"></div>
        <p>{{ $t("TABLES.loadingData") }}</p>
      </div>
      <form @submit.prevent="validateFormInputs" v-else>
        <div class="row">
          <!-- Representative commission per service (%) -->
          <base-input
            type="number"
            col="6"
            :placeholder="
              $t('PLACEHOLDERS.representative_commission_for_service')
            "
            v-model.trim="data.representative_commission_for_service"
            required
          />

          <!-- Management profit from orders (%) -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.management_profit')"
            v-model.trim="data.management_profit"
            required
          />

          <!-- Delivery price per kilometer -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.delivery_price')"
            v-model.trim="data.delivery_price"
            required
          />

          <!-- Order cancellation fees (%) -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.order_cancellation_fees')"
            v-model.trim="data.order_cancellation_fees"
            required
          />

          <!-- VAT Percentage (%) -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.additional_tax')"
            v-model.trim="data.tax"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSetting",
  data() {
    return {
      isWaitingRequest: false,
      loading: false,
      data: {
        representative_commission_for_service: null,
        management_profit: null,
        delivery_price: null,
        order_cancellation_fees: null,
        tax: null,
      },
    };
  },
  methods: {
    async getDataToEdit() {
      this.loading = true;
      try {
        let res = await this.$axios.get("settings?key=general-settings");
        const settings = res.data.data.data[0]?.value || {};

        this.data.representative_commission_for_service =
          settings.representative_commission_for_service ?? null;
        this.data.management_profit = settings.management_profit ?? null;
        this.data.delivery_price = settings.delivery_price ?? null;
        this.data.order_cancellation_fees =
          settings.order_cancellation_fees ?? null;
        this.data.tax = settings.tax ?? null;
      } catch (error) {
        console.error(error.response.data.message);
      } finally {
        this.loading = false;
      }
    },
    async submitForm() {
      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("key", "general-settings");
      REQUEST_DATA.append(
        "value[representative_commission_for_service]",
        this.data.representative_commission_for_service
      );
      REQUEST_DATA.append(
        "value[management_profit]",
        this.data.management_profit
      );
      REQUEST_DATA.append("value[delivery_price]", this.data.delivery_price);
      REQUEST_DATA.append(
        "value[order_cancellation_fees]",
        this.data.order_cancellation_fees
      );
      REQUEST_DATA.append(
        "value[tax]",
        this.data.tax
      );

      try {
        await this.$axios.post("settings", REQUEST_DATA);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    validateFormInputs() {
      // Representative commission per service (%) 0-100
      if (
        this.data.representative_commission_for_service === null ||
        this.data.representative_commission_for_service === "" ||
        isNaN(this.data.representative_commission_for_service) ||
        this.data.representative_commission_for_service < 0 ||
        this.data.representative_commission_for_service > 100
      ) {
        this.$message.error(
          this.$t("MESSAGES.representativeCommissionInvalid")
        );
        return;
      }

      // Management profit (%) 0-100
      if (
        this.data.management_profit === null ||
        this.data.management_profit === "" ||
        isNaN(this.data.management_profit) ||
        this.data.management_profit < 0 ||
        this.data.management_profit > 100
      ) {
        this.$message.error(this.$t("MESSAGES.managementProfitInvalid"));
        return;
      }

      // Delivery price (> 0)
      if (
        this.data.delivery_price === null ||
        this.data.delivery_price === "" ||
        isNaN(this.data.delivery_price) ||
        Number(this.data.delivery_price) <= 0
      ) {
        this.$message.error(this.$t("MESSAGES.deliveryPriceInvalid"));
        return;
      }

      // Order cancellation fees (%) 0-100
      if (
        this.data.order_cancellation_fees === null ||
        this.data.order_cancellation_fees === "" ||
        isNaN(this.data.order_cancellation_fees) ||
        this.data.order_cancellation_fees < 0 ||
        this.data.order_cancellation_fees > 100
      ) {
        this.$message.error(this.$t("MESSAGES.cancelOrderFeesInvalid"));
        return;
      }

      // VAT Percentage (%) 0-100
      if (
        this.data.tax === null ||
        this.data.tax === "" ||
        isNaN(this.data.tax) ||
        this.data.tax < 0 ||
        this.data.tax > 100
      ) {
        this.$message.error(this.$t("MESSAGES.vatRateRequired"));
        return;
      }

      this.submitForm();
    },
  },
  created() {
    this.getDataToEdit();
  },
};
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid var(--main_theme_clr);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
  }
  p {
    color: var(--theme_text_clr);
  }
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
